import React, { useCallback } from 'react';
import { useHistory } from 'react-router';

import type { Tab } from '../sticky-tab-nav/types';

import * as S from './styles';

type TabProps = Tab & {
  onClick?: (tab: string) => void;
};

type Props = {
  className?: string;
  onClick?: (tab: string) => void;
  tabs: Tab[];
  background?: boolean;
  isSticky?: boolean;
};

const TabItem = ({ active, id, onClick, scrollToTop, title, to }: TabProps) => {
  const history = useHistory();
  const handleOnClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (scrollToTop) {
        e.preventDefault();
        e.stopPropagation();

        // Scroll to top
        window.scrollTo({ top: 0, behavior: 'smooth' });

        // Remove potential hash from url
        history.push(history.location.pathname + history.location.search);
      }

      if (!onClick) return null;
      return onClick(id);
    },
    [id, onClick, scrollToTop, history]
  );

  return (
    <S.TabLink active={active} onClick={handleOnClick} to={to}>
      {title}
    </S.TabLink>
  );
};

export const Tabs = React.forwardRef<HTMLElement, Props>(
  ({ className, onClick, tabs, background, isSticky }, ref) => (
    <S.Tabs className={className} ref={ref}>
      <S.TabsBackground background={background} isSticky={isSticky}>
        <S.Wrapper>
          {tabs.map(tab => (
            <TabItem {...tab} key={tab.id} onClick={onClick} />
          ))}
        </S.Wrapper>
      </S.TabsBackground>
    </S.Tabs>
  )
);
